/* ReactionsDialogHeader.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import "./ReactionsDialogHeader.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useThemeObserver } from '@atlaskit/tokens';
import { CloseButton } from '@atlaskit/modal-dialog';
import { Tab, TabList } from '@atlaskit/tabs';
import { Box, Flex, Inline, Stack } from '@atlaskit/primitives/compiled';
import { IconButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import { useModal } from '@atlaskit/modal-dialog';
import Tooltip from '@atlaskit/tooltip';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import ChevronLeftIcon from '@atlaskit/icon/core/chevron-left';
import { ResourcedEmoji } from '@atlaskit/emoji/element';
import { messages } from '../shared/i18n';
import { Counter } from './Counter';
import { RESOURCED_EMOJI_COMPACT_HEIGHT } from '../shared/constants';
var styles = {
  leftNavigationStyle: "_19pk1b66 _1wpzynz6 _19bvpxbi _n3tdutpp",
  rightNavigationStyle: "_19pk1b66 _1wpzynz6 _18u01wug _2hwxu2gc",
  fullWidthStyle: "_1bsb1osq _ca0q1ejb _19bv1ejb _u5f31ejb _85i5xy5q",
  emoji: "_1rjc1b66 _8hrz1nam _bozgu2gc _y4ti1b66",
  counterStyle: "_19pkv77o"
};
var REACTIONS_CONTAINER_WIDTH = 56;
var REACTION_CONTAINER_HEIGHT = 40;
var customTabListStyles = null;
var customTabWrapper = {
  base: "_1o9zidpf _1e0c1txw _2lx21bp4 _y3gn1h6o _4cvr1h6o _1bah1h6o _1ul98vuz _vchhusvi _kqswh2mm _ogwtgrf3 _6tingrf3 _1cezgrf3 _m3zkgrf3 _6kbe8vuz _1yfp1ylp _dzc21h6o _tij01h6o _nhktlyvf _2t1tb3bt _mwnsstnw _axenidpf _1xogidpf _1gbg8vuz _rqy31ylp _1jzxidpf _j5n7ii5y _c0nrb3bt _1wqistnw _5e04idpf _clnfidpf _1ks28vuz _1ira1ylp _8bggidpf _10d67vkz _aezr7vkz",
  darkTheme: "_nhkt1ts8 _j5n7hco4"
};
var firstElement = null;
var LeftNavigationButton = function LeftNavigationButton(_ref) {
  var handlePreviousPage = _ref.handlePreviousPage;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: styles.leftNavigationStyle
  }, /*#__PURE__*/React.createElement(IconButton, {
    spacing: "compact",
    onClick: handlePreviousPage,
    icon: function icon(iconProps) {
      return /*#__PURE__*/React.createElement(ChevronLeftIcon, _extends({}, iconProps, {
        size: "small"
      }));
    },
    label: intl.formatMessage(messages.leftNavigateLabel),
    isTooltipDisabled: false
  }));
};
var RightNavigationButton = function RightNavigationButton(_ref2) {
  var handleNextPage = _ref2.handleNextPage;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: styles.rightNavigationStyle
  }, /*#__PURE__*/React.createElement(IconButton, {
    spacing: "compact",
    onClick: handleNextPage,
    icon: function icon(iconProps) {
      return /*#__PURE__*/React.createElement(ChevronRightIcon, _extends({}, iconProps, {
        size: "small"
      }));
    },
    label: intl.formatMessage(messages.rightNavigateLabel),
    isTooltipDisabled: false
  }));
};
export var ReactionsDialogHeader = function ReactionsDialogHeader(_ref3) {
  var totalReactionsCount = _ref3.totalReactionsCount,
    handlePreviousPage = _ref3.handlePreviousPage,
    handleNextPage = _ref3.handleNextPage,
    currentPage = _ref3.currentPage,
    maxPages = _ref3.maxPages,
    currentReactions = _ref3.currentReactions,
    emojiProvider = _ref3.emojiProvider,
    handleCloseReactionsDialog = _ref3.handleCloseReactionsDialog;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    cache = _useState2[0],
    setCache = _useState2[1];
  var _useModal = useModal(),
    titleId = _useModal.titleId;
  var intl = useIntl();
  var _useThemeObserver = useThemeObserver(),
    colorMode = _useThemeObserver.colorMode;
  var isSinglePage = maxPages === 1;
  var isOnFirstPage = currentPage === 1;
  var isOnLastPage = currentPage === maxPages;
  var handleMouseEnter = function handleMouseEnter(reaction) {
    var emojiId = reaction.emojiId;
    if (!emojiId || cache[emojiId]) {
      return;
    }
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var provider, emoji, capitalizedName;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return emojiProvider;
          case 2:
            provider = _context.sent;
            _context.next = 5;
            return provider.findByEmojiId({
              shortName: '',
              id: emojiId
            });
          case 5:
            emoji = _context.sent;
            if (emoji !== null && emoji !== void 0 && emoji.name) {
              // capitalize first letter of each string
              capitalizedName = emoji.name.replace(/\b\w/g, function (char) {
                return char.toUpperCase();
              });
              setCache(function (prevCache) {
                return _objectSpread(_objectSpread({}, prevCache), {}, _defineProperty({}, emojiId, capitalizedName));
              });
            }
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  };
  return /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    justifyContent: "space-between",
    alignItems: "center",
    xcss: styles.fullWidthStyle
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    id: titleId
  }, intl.formatMessage(messages.reactionsCount, {
    count: totalReactionsCount
  })), /*#__PURE__*/React.createElement(CloseButton, {
    onClick: handleCloseReactionsDialog
  })), /*#__PURE__*/React.createElement(Inline, null, /*#__PURE__*/React.createElement("div", {
    id: "reactions-dialog-tabs-list",
    className: ax(["_1reo1wug _18m91wug _n7zlfl6d _1e0c1txw _1bsb1osq _4cvr1y6m _80wau2gc _s2c4kb7n _141m1j28"]),
    style: {
      "--_1wtzbnt": ix("1px solid ".concat("var(--ds-border, #EBECF0)"))
    }
  }, !isSinglePage && !isOnFirstPage && /*#__PURE__*/React.createElement(LeftNavigationButton, {
    handlePreviousPage: handlePreviousPage
  }), /*#__PURE__*/React.createElement(TabList, null, currentReactions.map(function (reaction, index) {
    var emojiId = {
      id: reaction.emojiId,
      shortName: ''
    };
    return /*#__PURE__*/React.createElement("div", {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      className: ax([customTabWrapper.base, colorMode === 'dark' && customTabWrapper.darkTheme, index === 0 && "_19bvpxbi", "reaction-elements"]),
      key: reaction.emojiId,
      "data-testid": emojiId === null || emojiId === void 0 ? void 0 : emojiId.id,
      onMouseEnter: function onMouseEnter() {
        handleMouseEnter(reaction);
      }
    }, /*#__PURE__*/React.createElement(Tab, null, /*#__PURE__*/React.createElement(Tooltip, {
      content: cache[reaction.emojiId],
      canAppear: function canAppear() {
        return !!cache[reaction.emojiId];
      }
    }, /*#__PURE__*/React.createElement(Flex, {
      justifyContent: "center",
      alignItems: "center",
      direction: "row"
    }, /*#__PURE__*/React.createElement(Box, {
      xcss: styles.emoji
    }, /*#__PURE__*/React.createElement(ResourcedEmoji, {
      emojiProvider: emojiProvider,
      emojiId: emojiId,
      fitToHeight: RESOURCED_EMOJI_COMPACT_HEIGHT,
      showTooltip: true
    })), /*#__PURE__*/React.createElement(Box, {
      xcss: styles.counterStyle
    }, /*#__PURE__*/React.createElement(Counter, {
      value: reaction.count
    }))))));
  }), !isSinglePage && !isOnLastPage && /*#__PURE__*/React.createElement(RightNavigationButton, {
    handleNextPage: handleNextPage
  })))));
};